// app/javascript/controllers/frequency_toggle_controller.js
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["customIntervalBuilder"]

  toggleCustom(event) {
    const value = event.target.value
    const show = value === "custom"
    
    if (this.hasCustomIntervalBuilderTarget) {
      this.customIntervalBuilderTarget.classList.toggle("d-none", !show)
    }
  }
}